import {
  makeAutoObservable,
  reaction,
  computed,
  comparer,
  runInAction,
} from 'mobx';

import makeQuery from '../../api/makeQuery';
import Auth from '../../models/Auth';
import Users from '../../singletons/Users';
import GlobalEvents from '../../singletons/GlobalEvents';
import pick from '../../util/pick';
import safeJsonParse from '../../util/safeJsonParse';

const LS_NAME = 'MAJESTIC_SPUD_USER';
const ALLOWED_LOCALSTORAGE_KEYS = ['userId'];

class User {
  auth = new Auth();
  userId = '';
  lastSuccessfulPassword = '';

  constructor() {
    Object.assign(
      this,
      safeJsonParse(sessionStorage.getItem(LS_NAME), ALLOWED_LOCALSTORAGE_KEYS),
    );

    makeAutoObservable(this, {
      needsLogin: false,
      pusherPendingVisitIds: computed({equals: comparer.shallow}),
    });

    reaction(
      () => JSON.stringify(pick(this, ALLOWED_LOCALSTORAGE_KEYS)),
      (lsValue) => sessionStorage.setItem(LS_NAME, lsValue),
      {delay: 500},
    );

  }

  get needsLogin() {
    return !this.userId || this.auth.shouldRefreshTokenManually;
  }

  get user() {
    return this.userId ? Users.get(this.userId) : null;
  }

  async updateExpiredPassword(password) {
    if (!this.lastSuccessfulPassword) {
      throw new Error('Current password is unknown');
    }
    await this.updatePassword(password, this.lastSuccessfulPassword);
  }

  async updatePassword(password, oldPassword) {
    const res = await makeQuery('@putUpdatePassword', {
      password,
      oldPassword,
    });

    GlobalEvents.emit('updateUserPassword', {
      status: 'success',
    });

    return res;
  }

  async login(email, password) {
    const res =
      await makeQuery('@postLogin', {
        email,
        password,
      });

    const {auth, id, firstName, lastName, active} = res;

    runInAction(() => {
      this.lastSuccessfulPassword = password;
      this.auth.initialize({ ...auth, userId: id });

      /* Normally both provider and providerId should exist. Adding checks for extra safety. */
      if (id) {
        this.userId = id;
        Users.upsert(id, {  userId: id, firstName, lastName, email, active });
        console.log('upsert complete');
        // this.user?.posts?.refetch?.();
      }
    });

    if (process.env.NODE_ENV !== 'production') {
      console.log('loginData', auth, firstName, lastName, id);
    }
  }

  async handleForgotPassword(email) {
    try {
      const res = await makeQuery('@postForgotPassword', {
        email,
      });

      GlobalEvents.emit('forgotPassword', {
        status: 'success',
        email,
      });
      return res;
    } catch (e) {
      GlobalEvents.emit('forgotPassword', {
        status: 'error',
        email,
      });
    }
  }


  logout() {
    this.userId = '';
    this.auth.reset();
    Users.clear();
  }
}

export default new User();
